import React, { memo, useCallback, useContext, useMemo } from "react";

//contexts
import { UpdateCartContext } from "@cart-client/contexts/UpdateCartContext";
import { CartContext } from "@cart-client/contexts/CartContext";

//hooks
import { useCartRendererAnalytics } from "@cart-client/hooks/useCartRenderedAnalytics";

// helpers
import { getDeliverySectionComms } from "@cart-client/components/delivery-section-renderer/helpers";
import { isEmpty } from "@swiggy-private/js-utils";

// components
import { CartDeTip } from "@swiggy-private/cart-ui";
import { DeliverySectionCallout } from "../DeliverySectionCallout";
import { Wrapper, TipCalloutWrapper } from "./styles";

function TipWidget() {
    const {
        cartState: { localCart, reviewedCart: cartResponse },
    } = useContext(CartContext);
    const { updateCartInProgress, doUpdateCart } = useContext(UpdateCartContext);

    const {
        onImpressionTippingWidget,
        onClickPredefinedTipAmount,
        onClickCustomTipAmount,
        onClickTipOptIn,
        onImpressionTippingGrouping,
        onImpressionTippingGroupingActual,
    } = useCartRendererAnalytics(cartResponse);

    const updateTipDetails = useCallback(
        async ({ amount, optIn }: { amount: number; optIn: boolean }): Promise<void> => {
            if (!updateCartInProgress) {
                await doUpdateCart({
                    ...localCart,
                    tipDetails: {
                        amount,
                        optIn,
                    },
                });
            }
        },
        [doUpdateCart, updateCartInProgress, localCart],
    );

    const deliveryTipSectionTitle = useMemo(
        () => getDeliverySectionComms(cartResponse)?.delivery_tip_section_title,
        [cartResponse],
    );

    if (!cartResponse?.data?.tipExperimentData || !cartResponse?.data?.tipDetails) {
        return null;
    }

    return (
        <Wrapper>
            {!isEmpty(deliveryTipSectionTitle) && (
                <TipCalloutWrapper>
                    <DeliverySectionCallout message={deliveryTipSectionTitle} />
                </TipCalloutWrapper>
            )}
            <CartDeTip
                tipExperimentData={cartResponse?.data?.tipExperimentData}
                tipDetails={cartResponse?.data?.tipDetails}
                updateTipDetails={updateTipDetails}
                impressionTippingWidget={onImpressionTippingWidget}
                clickPredefinedTipAmount={onClickPredefinedTipAmount}
                clickCustomTipAmount={onClickCustomTipAmount}
                clickTipOptIn={onClickTipOptIn}
                onImpressionTippingGrouping={onImpressionTippingGrouping}
                onImpressionTippingGroupingActual={onImpressionTippingGroupingActual}
            />
        </Wrapper>
    );
}

export default memo(TipWidget);
